// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotFilledSvg from "@ant-design/icons-svg/es/asn/BoxPlotFilled";
import AntdIcon from '../components/AntdIcon';

var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotFilledSvg
  }));
};

BoxPlotFilled.displayName = 'BoxPlotFilled';
export default React.forwardRef(BoxPlotFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BoxPlotFilled.js
// module id = 675
// module chunks = 0